import { Line } from 'rc-progress'
import React from 'react'

const CourseProgress = ({courseModule}) => {
    return (
        <>
            <div className='flex font-medium text-sm justify-between mb-1'>
                <p>Course Progress</p>
                <p>{courseModule?.course_progress}% Completed</p>
            </div>
            <Line percent={courseModule?.course_progress} strokeColor={'#2BBD13'} strokeWidth={2} trailWidth={2}/>
        </>
    )
}

export default CourseProgress